/// <amd-module name="Artifacts/Root/helpers/TableHelper" />

import { ObservableValue } from "VSS/Core/Observable";
import { ITableColumn } from "VSSUI/Table";

export const resizeColumn = (
  columns: ITableColumn<unknown>[],
  index: number,
  width: number,
): ITableColumn<unknown>[] => {
  (columns[index].width as ObservableValue<number>).value = width;
  return columns;
};
